<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({
      currency: '',
      costs: []
    })
  },
  field: Object,
  label: String,
  path: Array,
  readonly: Boolean,
  density: String,
  drawerMode: Boolean
})

const emit = defineEmits(['update:modelValue'])

const costs = computed(() => props.modelValue.costs || [])

const editableFields = (item) => {
  return Object.keys(item).filter(
    key => key !== 'costId' && key !== '_id' && key !== "__typename"
  )
}

// function emitUpdatedCosts(updatedCosts) {
//   emit('update:modelValue', {
//     ...props.modelValue,
//     costs: updatedCosts.map(item => ({
//       ...item,  
//       costId:
//         typeof item.costId === 'object'
//           ? item.costId._id
//           : item.costId
//     }))
//   })
// }
// function updateValue(index, key, value) {
//   const updatedCosts = [...props.modelValue.costs]

//   updatedCosts[index] = {
//     ...updatedCosts[index],
//     [key]: value
//   }

//   // emitUpdatedCosts(updatedCosts)
// }

function updateValue(index, key, value) {
  const updated = [...props.modelValue.costs]

  updated[index] = {
    ...updated[index],
    [key]: value
  }

  emit('update:modelValue', {
    ...props.modelValue,
    costs: updated
  })
}

// function updateValue(index, key, value) {
//   const updatedCosts = [...props.modelValue.costs]

//   updatedCosts[index] = {
//     ...updatedCosts[index],
//     [key]: value
//   }

//   emit('update:modelValue', {
//     ...props.modelValue,
//     costs: updatedCosts
//   })
// }
</script>

<template>
     <v-col cols="12">
          Currency: {{ modelValue.currency }}
        </v-col>
  <v-card
    v-for="(cost, index) in costs"
    :key="cost.costId"
    class="mb-3"
    variant="outlined"
  >
        <v-col cols="12">
          <strong>{{ cost?.costId?.displayName }}</strong> 
        </v-col>
    <v-card-text>
      <v-row>

        <!-- Dynamic price fields -->
        <v-col
          v-for="field in editableFields(cost)"
          :key="field"
          cols="12"
          md="6"
        >
          <v-text-field
            :label="field"
            :model-value="cost[field]"
            type="number"
            step="0.01"
            min="0"
            @update:model-value="updateValue(index, field, $event)"
            :aria-label="cost[field]"

          />
        </v-col>

      </v-row>
    </v-card-text>
  </v-card>
</template>